import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router';

// hooks
import useAuth from 'hooks/useAuth';
// pages
import Login from 'pages/auth/Login';
// components
import LoadingScreen from 'components/LoadingScreen';
import { PATH_DASHBOARD, PATH_PRIVATE } from 'routes/paths';
import RoleBasedGuard from './RoleBasedGuard';

// ----------------------------------------------------------------------

export default function PrivateGuard({ children }) {
  const { isAuthenticated, isInitialized, authorizedIpp } = useAuth();
  const { ipp } = useParams();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  const checkPermission = [
    { path: PATH_DASHBOARD.demandes.list, show: false },
    { path: PATH_PRIVATE.demandes.list, show: true },

    { path: PATH_DASHBOARD.message.list, show: false },

    { path: PATH_DASHBOARD.account.edit, show: false },
    { path: PATH_DASHBOARD.delegation.list, show: false },
    { path: PATH_DASHBOARD.consultation.list, show: false },
    { path: PATH_DASHBOARD.association.list, show: false },
    { path: PATH_DASHBOARD.fusion.list, show: false },
    { path: PATH_DASHBOARD.setting.edit, show: false },

    { path: PATH_DASHBOARD.profile.list, show: false },
    { path: PATH_DASHBOARD.profile.add, show: false },

    { path: PATH_DASHBOARD.user.list, show: false },
    { path: PATH_DASHBOARD.user.add, show: false },

    { path: PATH_DASHBOARD.groups.list, show: false },
    { path: PATH_DASHBOARD.groups.add, show: false },

    { path: PATH_DASHBOARD.actor.list, show: false },
    { path: PATH_DASHBOARD.actor.add, show: false },
  ];

  const hasNotPermission = checkPermission?.findIndex((item) => pathname.includes(item.path) && item.show) === -1;

  if (hasNotPermission || authorizedIpp !== ipp)
    return <RoleBasedGuard />;

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
